export const unitToNumber = unit => unit ? parseInt(unit, 10) : 0;